export default __webpack_public_path__ + "static/media/IMG_5568.3f8a853c.jpg";